// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SiteAccountV2PatientsPatientAccountModel } from './siteAccountV2PatientsPatientAccountModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteAccountV2PatientsSearchPatientsResponse {
    'data': Array<SiteAccountV2PatientsPatientAccountModel>;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteAccountV2PatientsSearchPatientsResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "Array<SiteAccountV2PatientsPatientAccountModel>"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return SiteAccountV2PatientsSearchPatientsResponse.attributeTypeMap;
    }
}
